import { SIGNALR_GROUP_NAMES } from "@miplatform/constants";

export const dispatchNavItems = [
  {
    name: "Verification Review",
    path: "/dispatch/review",
    testId: "nav-item-dispatch-verification-review",
    signalrCountKey: SIGNALR_GROUP_NAMES.MiDispatch_VerificationReviewCount,
  },
];
